import React from 'react';
import CustomerIcon from "../../Images/peopleicon.png"
import "./DestinationInfo.css"
const DestinationInfo = (props) => {
    const {vehicle, seat} = props;
    const {name, image, seatFare} = vehicle;
    return (
        <div>
            <div className="destination-info-card">
                <img src={image} alt={name} className="vehicle-image"/>
                <h5 className="vehicle-name">{name}</h5>
                <h5 className="vehicle-seat">
                    <img src={CustomerIcon} alt="Seat"/> {seat}
                </h5>
                <h5 className="vehicle-fare">${seat * seatFare}</h5>
            </div> 
        </div>
    );
};

export default DestinationInfo;